document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".product-details-list-box");

  sections.forEach((section) => {
    const switchitems = section.querySelectorAll(".pro-details-item");

    const paginationTexts = Array.from(switchitems).map((item) => {
      return item.getAttribute("switch") || "";
    });

    new Swiper(section.querySelector(".product-details-container"), {
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: section.querySelector(".details-btn-next"),
        prevEl: section.querySelector(".details-btn-prev"),
      },
      pagination: {
        el: section.querySelector(".product-details-switchs"),
        clickable: true,
        renderBullet: function (index, className) {
          return `<span class="${className}">${
            paginationTexts[index] || ""
          }</span>`;
        },
      },
    });
  });

  const lableItmes = document.querySelectorAll(
    ".pro-item-variant .swatch-input__label"
  );
  const quantityLists = document.querySelectorAll(
    ".pro-item-quantity .quantity__button"
  );

  lableItmes.forEach((item) => {
    item.addEventListener("click", function () {
      const index = item.getAttribute("index");
      const parentAncestor = item.closest(".pro-details-item");
      const idItems = parentAncestor.querySelectorAll(".item-variant-id");

      idItems.forEach((el) => {
        const num = el.getAttribute("index");

        if (index == num) {
          const id = el.textContent;
          const url = el.getAttribute("url");
          const buyNowBtn = parentAncestor.querySelector(".buy-now-btn");
          const addToCartBtn = parentAncestor.querySelector(
            ".product-form__submit"
          );
          const img = parentAncestor.querySelector(".pro-item-img");
          buyNowBtn.dataset.variantId = id;
          addToCartBtn.dataset.variantId = id;
          img.setAttribute("src", url);
        }
      });
    });
  });

  quantityLists.forEach((item) => {
    item.addEventListener("click", function () {
      const parentAncestor = item.closest(".pro-details-item");
      const quantity = parentAncestor.querySelector(".quantity__input");
      const num = quantity.value;
      const buyNowBtn = parentAncestor.querySelector(".buy-now-btn");
      const addToCartBtn = parentAncestor.querySelector(
        ".product-form__submit"
      );
      buyNowBtn.dataset.quantity = num;
      addToCartBtn.dataset.quantity = num;
    });
  });
});
